import { jsx as _jsx } from "react/jsx-runtime";
import { Tab, Tabs } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
const DEALS_SUB_PAGES = [
    { label: "To Do", path: "/admin/deals" },
    { label: "Hot deals", path: "/admin/deals/hot" },
    { label: "All deals", path: "/admin/deals/all" },
];
/** Switches between today's follow-up queue, the daily Hot deals and every deal saved in the database */
export const DealsSubNav = () => {
    const { pathname } = useLocation();
    const currentPath = DEALS_SUB_PAGES.some((page) => page.path === pathname) ? pathname : DEALS_SUB_PAGES[0].path;
    return (_jsx(Tabs, Object.assign({ value: currentPath, sx: { mb: 3, borderBottom: 1, borderColor: "divider" }, "aria-label": "Deal pages" }, { children: DEALS_SUB_PAGES.map((page) => (_jsx(Tab, { label: page.label, value: page.path, component: Link, to: page.path }, page.path))) })));
};
